import { render, staticRenderFns } from "./MitraCoverage.vue?vue&type=template&id=77c98026&"
import script from "./MitraCoverage.vue?vue&type=script&lang=js&"
export * from "./MitraCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports